<div class="card-mini tw:cursor-pointer tw:text-center tw:relative"
  (click)="item.action()">
  @if (item.notification) {
    <div class="notification tw:flex tw:justify-center tw:items-center tw:bg-app-danger tw:absolute">
      {{ item.notification }}
    </div>
  } @else {
    @if (item.notification$ | async; as notification) {
      <div class="notification tw:flex tw:justify-center tw:items-center tw:bg-app-danger tw:absolute">
        {{ notification }}
      </div>
    }
  }
  @if (item.icon) {
    <ion-icon [name]="item.icon"></ion-icon>
  }
  @if (item.title) {
    <div class="title">
      {{ item.title }}
    </div>
  }
  <div class="tw:truncate">{{ item.name | translate }}</div>
</div>